import { Component, OnInit } from '@angular/core';
import { ChatbotService } from './chatbot.service';
import { ChatbotMessage } from '../base/vo/chatbot-message';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css']
})
export class ChatbotComponent implements OnInit {

  public isChatVisible: boolean;
  public isChatStarted: boolean;
  public isLoading: boolean;
  public isCancel: boolean;

  public messages: Array<ChatbotMessage> = [];
  public context: any;

  public messageText: string = "";
  public protocolo: string = "";

  public activityExpiration: number;
  public activityTimeout: any;

  constructor(private autenticacaoService: AutenticacaoService, private chatbotService: ChatbotService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  abrirChat() {
    this.isChatVisible = true;
  }

  fecharChat() {
    this.registraConversa();

    this.isChatVisible = false;
    this.isChatStarted = false;
    this.messages = [];
    this.context = undefined;
    this.messageText = "";
    this.protocolo = "";
    this.activityExpiration = 0;
  }

  gerarProtocolo() {
    this.isChatStarted = true;
    this.isLoading = true;

    this.chatbotService.gerarProtocolo().subscribe(response => {
      this.protocolo = response.data.numeroProtocolo;
      this.activityExpiration = response.data.expirationChatbot;
      this.iniciarChat();
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  private iniciarChat() {
    this.isChatStarted = true;
    // this.context = { codigoPrestador: this.autenticacaoService.usuarioLogado.username };
    this.context = { codigoPrestador: this.autenticacaoService.usuarioLogado.username, nomePrestador: this.autenticacaoService.usuarioLogado.nome };
    this.serviceMensagem("");
  }

  enviarMensagem() {
    const currentMessage = this.messageText;

    if (currentMessage.trim() != "") {

      if(this.isCancel) {
        let procedimntosSelecionados = this.getProcedimentosSelecionados();

        this.isCancel = false;
        this.messages.push(new ChatbotMessage(currentMessage, "user", undefined, new Date()));

        if(procedimntosSelecionados.length > 0) {
          this.context["itensSelecionados"] = procedimntosSelecionados;
        }
      } else {
        this.messages.push(new ChatbotMessage(currentMessage, "user", undefined, new Date()));
      }

      this.serviceMensagem(currentMessage);
    }
  }

  private serviceMensagem(mensagem) {
    this.updateChatTimeout();
    this.isLoading = true;
    this.messageText = "";

    setTimeout(() => {
      this.scrollToBottom();
    }, 1);

    this.chatbotService.enviarMensagem(this.context, mensagem).subscribe(response => {      
      this.setMessages(response);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  private updateChatTimeout() {

    if(this.activityTimeout) {
      clearTimeout(this.activityTimeout);
    }

    this.activityTimeout = setTimeout(() => {
      this.fecharChat();
    }, this.activityExpiration * 1000);
  }

  private registraConversa() {
    let texto: string = "";

    this.messages.find(x => x.origin == "user");
    
    this.messages.filter(x => x.origin == "user").forEach(userMessage => {
      texto += userMessage.timestamp + " " + userMessage.text + "|";
    });

    texto = texto.substring(0, texto.length-1);

    this.chatbotService.registrarConversa(this.protocolo, texto).subscribe(response => {
      // console.log(response);
    }, error => {
      console.log(error);
    });
  }

  escolherAcao(mensagem) {
    this.messageText = mensagem;
    this.enviarMensagem();
  }

  enviarMensagemKeydown(event) {
    if (event.key === "Enter") {
      this.enviarMensagem();
    }
  }

  private setMessages(responseObj) {
    this.context = responseObj.context;

    responseObj.output.generic.forEach(generic => {

      if(generic.response_type == "text") {

        if (generic.text == "montarBtnCancelGTO") {
          this.setCancelarItems(responseObj.context);          
        } else {
          this.messages.push(new ChatbotMessage(generic.text, "nina"));
        }
      }

      if(generic.response_type == "option") {
        this.messages.push(new ChatbotMessage(generic.title, "nina", generic.options));
      }
    });

    this.setLastMessage();
  }

  private setLastMessage() {
    setTimeout(() => {
      const ninaMessages = document.getElementsByClassName("nina-text");
  
      for (let i = 0; i < ninaMessages.length; i++) {
        ninaMessages[i].classList.remove("last-message");
      }
  
      ninaMessages[ninaMessages.length - 1].classList.add("last-message");

      this.scrollToBottom();
    }, 1);
  }

  private scrollToBottom() {
    const element = document.getElementsByClassName("chat-container")[0];
    const to = element.scrollHeight;
    element.scrollTo(0, to);
  }

  private setCancelarItems(context) {
    this.isCancel = true;
    let msgText = context.msgCancelarProcedimentos;

    msgText += `<label><input type="checkbox" value="todos" name="checkItens" 
                        onchange="for(var i=0; i<this.parentElement.parentElement.getElementsByTagName('input').length; i++) { this.parentElement.parentElement.getElementsByTagName('input')[i].checked = this.checked; }" 
                        />TODOS</label><br>`
                        
    context.resultGetGTO.resultado.procedimentos.forEach(procedimento => {
      if(procedimento.procedimentoCancelavel) {
        msgText += `<label><input type="checkbox" value="${procedimento.linha}" name="checkItens"
                        onchange="if(!this.checked) { this.parentElement.parentElement.getElementsByTagName('input')[0].checked=false; }">${procedimento.descricaoProcedimento}</label><br>`
      }
    });
    this.messages.push(new ChatbotMessage(msgText, "nina"));
  }

  private getProcedimentosSelecionados() {
    let arrProcedimentos: Array<any> = [];
    let domProcedimentosBlock: any = document.getElementsByClassName("nina-text");
    let domProcedimentosInputs: any = domProcedimentosBlock[domProcedimentosBlock.length - 2].getElementsByTagName("input");
    
    for (let index = 0; index < domProcedimentosInputs.length; index++) {
      const element = domProcedimentosInputs[index];
      
      if(index > 0 && element.checked) {
        arrProcedimentos.push({
          motivo: "Cancelamento via chatbot",
          numeroItem: element.value
        });
      }
    }

    return arrProcedimentos;
  }

  public sanitizeMessage(message) : SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/chatbot/chatbot.component.ts